
  import { mapState } from 'vuex'
  import dayjs from 'dayjs'
  import duration from 'dayjs/plugin/duration'
  import utc from 'dayjs/plugin/utc'
  import timezone from 'dayjs/plugin/timezone'

  dayjs.extend(duration)
  dayjs.extend(utc)
  dayjs.extend(timezone)
  export default {
    props: {
      activityType: {
        type: Number,
        default: 1
      }
    },
    computed: {
      ...mapState({
        missions: state => state.activities['mission-reward'].missions,
        missionsLoading: state => state.activities['mission-reward'].missionsLoading,
        defaultCurrency: state => state.settings.defaultCurrency
      }),
      missionsList() {
        return this.missions[this.activityType]
      },
      loading() {
        return this.missionsLoading[this.activityType]
      }
    },
    mounted() {
      this.fetchMissions()
      // refetch the missions on Socket
      this.subscribeAction = this.$store.subscribeAction((mutation, state) => {
        if (mutation.type === 'sockets/missionActivityUnlocked') {
          this.fetchMissions()
        }
      })
    },
    beforeDestroy() {
      // unsubscribe the store action
      if (this.subscribeAction) {
        this.subscribeAction()
      }
    },
    methods: {
      fetchMissions() {
        this.$store.dispatch('activities/mission-reward/getMissions', {
          mission_type: this.activityType,
          currency: this.defaultCurrency
        })
      },
      getMissionStatus(item) {
        const obj = {
          text: null,
          color: null
        }
        const startDate = dayjs
          .tz(
            this.$dayjs(item.start_date).startOf('day').format('YYYY-MM-DD HH:mm:ss'),
            item.timezone
          )
          .local()
        const endDate = dayjs
          .tz(this.$dayjs(item.end_date).endOf('day').format('YYYY-MM-DD HH:mm:ss'), item.timezone)
          .local()
        const todayDate = this.$dayjs().startOf('day')
        if (todayDate.isSameOrAfter(startDate) && todayDate.isSameOrBefore(endDate)) {
          obj.text = this.tl('running')
          obj.color = 'success'
        } else if (todayDate.isBefore(startDate)) {
          obj.text = this.tl('upcoming')
          obj.color = null
        } else if (todayDate.isAfter(endDate)) {
          obj.text = this.tl('expired')
          obj.color = 'error'
        }
        return obj
      }
    }
  }
